module.exports = __webpack_public_path__ + "static/media/info.356219e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/info.svg
// module id = 685
// module chunks = 0